<ng-template>
    <input
        type="text"
        name="daterange"
        ngxDaterangepickerMd
        [(ngModel)]="selected"
        (datesUpdated)="onDateChange($event)"
        (clearClicked)="clearDateFilter()"
        [showCustomRangeLabel]="true"
        [alwaysShowCalendars]="true"
        [linkedCalendars]="false"
        [showClearButton]="true"
        [locale]="locale"
        [maxDate]="maxDate"
        [ranges]="ranges"
        [placeholder]="placeholder"
        [keepCalendarOpeningWithRange]="true"
        class="date-picker-input rounded-pill"
        [ngClass]="{ 'date-picker-input-highlight': isDateFilterApplied }"
    />
</ng-template>
